<template>
  <v-app>
    <v-main>
      <v-parallax
        src="/images/lovina8.jpg"
        height="106vh"
        style="width:100vw;"
        cover
      >
        <div class="d-flex flex-column fill-height justify-center align-center text-white text-bold" style="position: relative;">
          <!-- Example logo -->
          <v-col cols="auto" class="pa-0">
            <v-img
              src="Lo.Green.2_transparent.ico"
              alt="Logo"
              class="navbar-logo"
            ></v-img>
          </v-col>

          <!-- Booking Card -->
          <v-card
            elevation="10"
            rounded="lg"
            color="transparent"
            style="background-color: rgba(255,255,255,0.9); padding: 20px; max-width:600px; width:90%;"
          >
            <v-row align="center" justify="center" dense>
              <!-- Check-in Field -->
              <v-col cols="12" sm="4" class="pa-1">
                <v-text-field
                  bg-color="indigo-lighten-4"
                  variant="solo-filled"
                  v-model="startDate"
                  :label="$t('bookingForm.checkin')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  @click="openStartDialog"
                ></v-text-field>
              </v-col>

              <!-- Check-out Field -->
              <v-col cols="12" sm="4" class="pa-1">
                <v-text-field
                  bg-color="indigo-lighten-4"
                  variant="solo-filled"
                  v-model="endDate"
                  :label="$t('bookingForm.checkout')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  @click="openEndDialog"
                ></v-text-field>
              </v-col>

              <!-- Book Now Button -->
              <v-col cols="12" sm="8" class="d-flex align-center">
                <v-btn
                  size="x-large"
                  rounded="xl"
                  with-ripple
                  block
                  color="yellow"
                  :disabled="!startDate || !endDate"
                  @click="goToBookingForm"
                >
                {{ $t('navbar.bookNow') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-parallax>

      <!-- Check-in Date Dialog -->
      <v-dialog v-if="unavailableDatesLoaded" v-model="startDialog" max-width="330px">
        <v-card>
          <v-card-title class="text-h6">{{$t('bookingForm.checkin')}}</v-card-title>
          <v-date-picker
            v-model="startDate"
            :min="today"
            :allowed-dates="allowedCheckinDates"
            @input="closeStartDialog"
          >
            <!-- Show "X" on blocked days -->
            <template v-slot:day="{ date }">
              <div class="text-center" style="width:2em; height:2em; display:flex; align-items:center; justify-content:center;">
                <span v-if="!allowedCheckinDates(date)">X</span>
                <span v-else>{{ new Date(date).getDate() }}</span>
              </div>
            </template>
          </v-date-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="startDialog = false">{{ $t('bookingForm.ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Check-out Date Dialog -->
      <v-dialog v-if="unavailableDatesLoaded" v-model="endDialog" max-width="330px">
        <v-card>
          <v-card-title class="text-h6">{{$t('bookingForm.checkout') }}</v-card-title>
          <v-date-picker
            v-model="endDate"
            :min="startDate || today"
            :allowed-dates="allowedCheckoutDates"
            @input="closeEndDialog"
          >
            <template v-slot:day="{ date }">
              <div class="text-center" style="width:2em; height:2em; display:flex; align-items:center; justify-content:center;">
                <span v-if="!allowedCheckoutDates(date)">X</span>
                <span v-else>{{ new Date(date).getDate() }}</span>
              </div>
            </template>
          </v-date-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="endDialog = false">{{ $t('bookingForm.ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import apiService from '@/services/apiService.js'; // Import the updated apiService

export default {
  data() {
    return {
      // Will store local date strings (e.g. "Wed Dec 25 2024...")
      startDate: null,
      endDate: null,

      startDialog: false,
      endDialog: false,
      today: new Date().toISOString().substr(0,10),

      // Arrays from backend to block
      unavailableCheckinDates: [],
      unavailableCheckoutDates: []
    }
  },
  computed: {
    unavailableDatesLoaded() {
      return Array.isArray(this.unavailableCheckinDates) && Array.isArray(this.unavailableCheckoutDates)
    }
  },
  mounted() {
    apiService.fetchUnavailableDates()
      .then(res => {
        this.unavailableCheckinDates = res.data.unavailable_checkin_dates
        this.unavailableCheckoutDates = res.data.unavailable_checkout_dates
        //console.log("unavailableCheckin:", this.unavailableCheckinDates)
        //console.log("unavailableCheckout:", this.unavailableCheckoutDates)
      })
      .catch(err => console.error("Failed to load unavailable dates:", err))
  },
  methods: {
    // For check-in
    allowedCheckinDates(date) {
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      const dateString = `${yyyy}-${mm}-${dd}`
      return !this.unavailableCheckinDates.includes(dateString)
    },
    // For check-out
    allowedCheckoutDates(date) {
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      const dateString = `${yyyy}-${mm}-${dd}`
      return !this.unavailableCheckoutDates.includes(dateString)
    },
    openStartDialog() {
      if (this.unavailableDatesLoaded) {
        this.startDialog = true
      }
    },
    openEndDialog() {
      if (this.unavailableDatesLoaded) {
        this.endDialog = true
      }
    },
    closeStartDialog() {
      this.startDialog = false
      if (this.endDate && this.startDate && this.startDate > this.endDate) {
        this.endDate = null
      }
    },
    closeEndDialog() {
      this.endDialog = false
    },
    goToBookingForm() {
      //console.log("Navigating with:", this.startDate, this.endDate)
      // Pass both start_date and end_date
      this.$router.push({
        path: '/book',
        query: {
          start_date: this.startDate,
          end_date: this.endDate
        }
      })
    }
  }
}
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}
.navbar-logo {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
